import { Card } from "../common/Card";

const COLOR_PALETTE = [
  "#1E61DC",
  "#3B82F6",
  "#60A5FA",
  "#93C5FD",
  "#BFDBFE",
  "#DBEAFE",
];

export function RevenueHeatmap({ revenueByGeography = [], loading }) {
  const hasData = revenueByGeography?.length > 0;

  return (
    <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
      <h3 className="mb-6 text-[#1A1A1A]">Revenue by Geography</h3>

      {loading ? (
        <div className="h-[200px] flex items-center justify-center">
          <div className="w-8 h-8 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin" />
        </div>
      ) : hasData ? (
        <div className="space-y-4">
          {revenueByGeography.map((region, index) => (
            <div key={region.continent} className="space-y-2">
              <div className="flex items-center justify-between text-[#1A1A1A]">
                <span>{region.continent}</span>
                <span>₦{region.revenue.toLocaleString()}</span>
              </div>

              <div className="h-8 bg-gray-100 rounded-lg overflow-hidden">
                <div
                  className="h-full rounded-lg flex items-center justify-end px-3 transition-all"
                  style={{
                    width: `${region.percentage ?? 0}%`,
                    backgroundColor:
                      COLOR_PALETTE[index % COLOR_PALETTE.length],
                  }}
                >
                  <span className="text-white">
                    {region.percentage?.toFixed(1)}%
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="h-[200px] flex items-center justify-center text-gray-500">
          No geography revenue data available
        </div>
      )}
    </Card>
  );
}
